export default {
      id: "shops-usage",
      viewBox: "0 0 18 19",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#shops",
      toString: function () {
        return this.url;
      }
    }